@use '../../../../../scss/settings/colors.scss';

.actionButton {
  padding: 1px;
  color: colors.$gray-variant-16;

  svg {
    width: 20px;
    height: 20px;
  }

  &:hover {
    background-color: rgba(0, 0, 0, 0.04);
  }
}